import { Drawer, message, Tabs } from 'antd';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import { useStores } from '@/hooks/use-stores';
import CloseIcon from '@/comp/common/icons/CloseIcon';
import EPIconButton from '@/components/EPButton/EPIconButton';

import { Entity } from '../NodeWidget.types';
import { EditAssetDrawerContainer } from './EditAssetDrawer.styles';
import { getDeviceSuperType } from './EditAssetDrawer.utils';
import { getTabItems } from '../EditAssetDrawer/EditAssetDrawer.utils';

interface EditAssetDrawerProps {
  isEditAssetModalOpen: boolean;
  entity: Entity;
}

const EditAssetDrawer = observer(({ isEditAssetModalOpen, entity }: EditAssetDrawerProps) => {
  const { pidEditStore, stationStore } = useStores();
  const { t } = useTranslation();
  const [afterOpenChange, setAfterOpenChange] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState('compressorDetails');
  const [messageApi, contextHolder] = message.useMessage();

  const onTabChange = (key: string) => {
    if (key === 'compressorDetails' && hasUnsavedChanges) messageApi.error(t('unsavedChanges'));
    else setActiveTabKey(key);
  };

  const onClose = () => {
    if (hasUnsavedChanges) messageApi.error(t('unsavedChanges'));
    else pidEditStore.hideMenu();
  };

  const onMouseAction = e => e.stopPropagation();

  return (
    <Drawer
      open={isEditAssetModalOpen}
      onClose={onClose}
      width={400}
      closeIcon={false}
      destroyOnClose
      afterOpenChange={setAfterOpenChange}
      push={false}
      mask={false}
    >
      <EditAssetDrawerContainer
        onMouseDown={onMouseAction}
        onMouseUp={onMouseAction}
        onTouchStart={onMouseAction}
        onTouchEnd={onMouseAction}
        onWheel={onMouseAction}
      >
        {contextHolder}
        <div className="header">
          <EPIconButton icon={<CloseIcon />} onClick={onClose} />
        </div>
        <div className="body-header">
          {t('editDeviceDetails', { device: t(`${getDeviceSuperType(entity.deviceType)}`) })}
        </div>
        <Tabs
          items={getTabItems(entity, t, afterOpenChange, setHasUnsavedChanges, stationStore.currentStation.stationTier)}
          className="asset-details-tabs"
          destroyInactiveTabPane
          activeKey={activeTabKey}
          onChange={onTabChange}
        />
      </EditAssetDrawerContainer>
    </Drawer>
  );
});

export default EditAssetDrawer;
